import imageProject from './img/project.jpg'
import imageContext from './img/context.jpg'
import imagePlan from './img/plan.png'
import imageFocusGroup from './img/M123-template_M1.png'
import imageMiro from './img/M123-template_M2.png'
import imageFieldStudy from './img/M123-template_M3.png'

import imageDesign1 from './img/Fig2.jpg'
import imageDesign2 from './img/Fig3a.jpg'
import imageDesign3 from './img/Fig3b.jpg'
import imageDesign4 from './img/Fig1b.jpg'

import imageMore1 from './img/more/Fig1a.jpg'
import imageMore2 from './img/more/Fig1c.jpg'
import imageMore3 from './img/more/Fig1d.jpg'
import imageMore4 from './img/more/Fig7b.jpg'
import imageMore5 from './img/more/Fig7a.png'
import imageMore6 from './img/more/1.png'
import imageMore7 from './img/more/2.png'
import imageMore8 from './img/more/3.png'
import imageMore9 from './img/more/4.png'
import imageMore10 from './img/more/5.png'

const images = {

  singles: {
    imageProject:    { src: imageProject, alt: 'PhotoClock Design' },
    imageContext:    { src: imageContext, alt: 'PhotoClock Design' },
    imagePlan:       { src: imagePlan, alt: 'PhotoClock Design' },
    imageFocusGroup: { src: imageFocusGroup, alt: 'PhotoClock Use Scenario' },
    imageMiro:       { src: imageMiro, alt: 'PhotoClock Use Scenario' },
    imageFieldStudy: { src: imageFieldStudy, alt: 'PhotoClock Use Scenario' },
  },

  design: [
    { src: imageDesign1, alt: 'PhotoClock Design' },
    { src: imageDesign2, alt: 'PhotoClock Design' },
    { src: imageDesign3, alt: 'PhotoClock Design' },
    { src: imageDesign4, alt: 'PhotoClock Use Scenario' },
  ],

  more: [
    { src: imageMore1, alt: 'PhotoClock Design' },
    { src: imageMore2, alt: 'PhotoClock Design' },
    { src: imageMore3, alt: 'PhotoClock Design' },
    { src: imageMore4, alt: 'PhotoClock Use Scenario' },
    { src: imageMore5, alt: 'PhotoClock Design' },
    { src: imageMore6, alt: 'PhotoClock Design' },
    { src: imageMore7, alt: 'PhotoClock Design' },
    { src: imageMore8, alt: 'PhotoClock Use Scenario' },
    { src: imageMore9, alt: 'PhotoClock Design' },
    { src: imageMore10, alt: 'PhotoClock Use Scenario' },
  ],
};

export default images;